import { useParamsSearch } from '@anytag/shared-hooks';
import { PostReportSearchSchemaType } from '../schema-types';

export const usePostReportFilter = () => useParamsSearch<PostReportSearchSchemaType>();
